export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isFunction.js
// module id = 264
// module chunks = 1